import { cx } from "class-variance-authority";

import { ReactComponent as CloseIcon } from "./assets/close.svg";
import * as styles from "./RemoveButton.module.scss";

type RemoveButtonProps = {
  className?: string;
  onClick: () => void;
};

const RemoveButton = ({ onClick, className }: RemoveButtonProps) => {
  return (
    <div className={cx(styles.remove, className)} onClick={onClick}>
      <CloseIcon />
    </div>
  );
};

export { RemoveButton };
